
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetovadodaracabtaxi() {



    const cardData =
    {
        keyword: 'Pune to Vadodara Cab Taxi ',
        heading: 'Platinum24 Cabs: Pune to Vadodara Cab Taxi',
        headingDescription: ' Platinum24 Cabs offers reliable Pune to Vadodara cab taxi services, ideal for business travelers, family visits, and long-distance journeys across Gujarat. Whether you’re heading to Vadodara for corporate meetings, visiting Laxmi Vilas Palace, or exploring Sayaji Baug and local cultural sites, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a smooth and safe ride. With experienced chauffeurs, punctual service, and transparent pricing, we make your intercity travel convenient and stress-free. From one-way drops to customized round trips, Platinum24 Cabs guarantees a dependable Pune to Vadodara travel experience for every passenger.',

        top: 'Top Places to Visit in Vadodara with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Laxmi Vilas Palace",
    "description": "Laxmi Vilas Palace, built in 1890 by Maharaja Sayajirao Gaekwad III, is four times larger than Buckingham Palace. Its Indo-Saracenic architecture, stained glass, marble halls, and mosaics reflect royal grandeur. The palace museum displays weapons, paintings, and artifacts of the Gaekwad dynasty. Surrounding gardens and a golf course enhance its charm. Cultural events and concerts are often held here. Laxmi Vilas is Vadodara’s iconic royal landmark."
  },
  {
    "title": "Sayaji Baug (Kamati Baug)",
    "description": "Sayaji Baug, also called Kamati Baug, is Vadodara’s largest public garden spread over 100 acres. It houses a zoo, planetarium, museum, and a toy train for children. The garden is beautifully landscaped with fountains and lawns. Families love spending evenings here. Built by Maharaja Sayajirao Gaekwad III, it symbolizes his vision of public welfare. Sayaji Baug is Vadodara’s green cultural hub."
  },
  {
    "title": "Baroda Museum & Picture Gallery",
    "description": "The Baroda Museum, established in 1894, is one of India’s finest museums. It displays sculptures, Mughal miniatures, European paintings, Egyptian mummies, and natural history specimens. The adjacent Picture Gallery has works by European masters. Its Indo-Saracenic building adds to its charm. Students and history lovers find it enriching. This museum is Vadodara’s treasure house of art and knowledge."
  },
  {
    "title": "Kirti Mandir",
    "description": "Kirti Mandir, built by Maharaja Sayajirao Gaekwad III, is a cenotaph honoring the Gaekwad rulers. Its central shikhara depicts murals of Mahabharata and Ramayana scenes. The marble interiors and paintings reflect cultural richness. Located near the Vishwamitri River, it offers a peaceful atmosphere. Visitors admire its heritage value and architecture. Kirti Mandir is Vadodara’s royal memorial of legacy."
  },
  {
    "title": "EME Temple (Dakshinamurthy Temple)",
    "description": "The EME Temple, maintained by the Indian Army, is dedicated to Lord Dakshinamurthy (Shiva as a teacher). Its aluminum-clad geodesic structure makes it architecturally unique. The temple integrates designs from Hindu, Christian, Islamic, and Buddhist styles, symbolizing unity. Surrounded by gardens, it exudes serenity. Visitors also explore its cultural exhibits. EME Temple is Vadodara’s spiritual landmark with a modern touch."
  },
  {
    "title": "Nyay Mandir",
    "description": "Nyay Mandir, meaning Temple of Justice, is an Indo-Saracenic-style building housing Vadodara’s District Court. Built in 1896, it was designed by Robert Fellowes Chisholm. The building has stunning domes, stained glass, and carved arches. Though primarily judicial, its architecture attracts heritage enthusiasts. It reflects the Gaekwad dynasty’s vision of justice and progress. Nyay Mandir is Vadodara’s historic architectural gem."
  },
  {
    "title": "Maharaja Fateh Singh Museum",
    "description": "The Maharaja Fateh Singh Museum, located inside the Laxmi Vilas Palace estate, displays royal collections. It includes European paintings, sculptures, and works by Raja Ravi Varma. The museum also showcases marble and bronze statues. Visitors admire artifacts reflecting the Gaekwad dynasty’s artistic taste. It is surrounded by lush greenery, making the visit pleasant. This museum is Vadodara’s cultural jewel."
  },
  {
    "title": "Nazarbaug Palace",
    "description": "Nazarbaug Palace, built in 1721, was once the Gaekwad family’s treasury. It stored jewels, including the famous Star of the South diamond. Though partly in ruins today, it retains historical significance. The palace’s structure narrates tales of royal opulence. Heritage lovers find it fascinating despite its faded grandeur. Nazarbaug is Vadodara’s glimpse into regal treasures of the past."
  },
  {
    "title": "Sur Sagar Lake",
    "description": "Sur Sagar Lake, also called Chand Talao, is a scenic water body in the heart of Vadodara. A 120-foot statue of Lord Shiva stands majestically in the middle. Evening lighting adds beauty to the site. During festivals, the lakefront is buzzing with devotees and tourists. Boating and photography make it popular. Sur Sagar Lake is Vadodara’s serene spiritual retreat."
  },
  {
    "title": "Ajwa Water Park & Gardens",
    "description": "Ajwa Gardens and Water Park, located 18 km from Vadodara, are popular for family outings. The gardens are landscaped with fountains, lawns, and musical shows. The water park offers thrilling rides, pools, and slides. It is ideal for kids and adventure seekers alike. Picnics and weekend trips make it lively. Ajwa is Vadodara’s fun-filled recreation spot."
  }
],


               "services": [
    {
      "name": "Pune to Vadodara Cab",
      "description": "Travel comfortably and safely with our Pune to Vadodara Cab service, offering reliable long-distance transportation with well-maintained vehicles and professional drivers."
    },
    {
      "name": "Pune to Vadodara Taxi",
      "description": "Our Pune to Vadodara Taxi service provides timely, affordable, and hassle-free travel for both business and leisure passengers, ensuring a smooth interstate journey."
    },
    {
      "name": "Book Pune to Vadodara Cab",
      "description": "Easily book your Pune to Vadodara Cab online with instant confirmation and flexible scheduling, making your travel planning effortless and convenient."
    },
    {
      "name": "Pune to Vadodara Car Hire",
      "description": "Choose from a wide range of cars for Pune to Vadodara Car Hire, including self-drive and chauffeur-driven options tailored to suit your travel needs."
    },
    {
      "name": "Pune to Vadodara Outstation Cab",
      "description": "Our Pune to Vadodara Outstation Cab service is perfect for long-distance travel, featuring comfortable vehicles and experienced drivers familiar with highway routes."
    },
    {
      "name": "Pune to Vadodara One Way Taxi",
      "description": "Save on your one-way trip with our Pune to Vadodara One Way Taxi service, ideal for relocations, business trips, or travel where return rides are not needed."
    },
    {
      "name": "Pune to Vadodara Taxi Booking",
      "description": "Book your Pune to Vadodara Taxi easily and securely with our online platform, offering real-time availability and competitive pricing."
    },
    {
      "name": "Cab from Pune to Vadodara",
      "description": "Reliable Cab from Pune to Vadodara service available 24/7, ensuring safe and comfortable travel between the two cities with professional drivers."
    },
    {
      "name": "Vadodara to Pune Cab Service",
      "description": "Plan your return journey with our Vadodara to Pune Cab Service, featuring prompt pickups, well-maintained vehicles, and courteous drivers."
    },
    {
      "name": "Affordable Pune to Vadodara Cabs",
      "description": "Enjoy budget-friendly travel with our Affordable Pune to Vadodara Cabs, combining comfort and cost-effectiveness for all types of travelers."
    },
    {
      "name": "Pune to Vadodara Drop Taxi",
      "description": "Our Pune to Vadodara Drop Taxi service offers direct point-to-point transportation with transparent pricing and reliable service."
    }
  ],
  "tableData": [
    ["Pune to Vadodara Cab", "Pune to Vadodara Taxi"],
    ["Book Pune to Vadodara Cab", "Pune to Vadodara Car Hire"],
    ["Pune to Vadodara Outstation Cab", "Pune to Vadodara One Way Taxi"],
    ["Pune to Vadodara Taxi Booking", "Cab from Pune to Vadodara"],
    ["Vadodara to Pune Cab Service", "Affordable Pune to Vadodara Cabs"],
    ["Pune to Vadodara Drop Taxi", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Pune to Vadodara Cab Taxi Service",
    "WhyChoosedescription": "Platinum24 Cabs offers comfortable and dependable cab taxi services for your Pune to Vadodara journey, ensuring a smooth and hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Fit Your Travel Needs",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers, all well-maintained and perfect for the Pune to Vadodara route."
  },
  {
    "WhyChooseheading": "Sanitized and Clean Vehicles for Safe Travel",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and hygienic environment during your trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Our professional drivers are familiar with the Pune to Vadodara route, ensuring timely and efficient travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and affordable fares that include tolls, fuel, and driver allowances for worry-free travel."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Convenient Booking",
    "WhyChoosedescription": "Our dedicated customer support team is available round the clock to assist you with your Pune to Vadodara cab taxi bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Trips",
    "WhyChoosedescription": "Select from hourly, daily, or long-term rental plans tailored to your Pune to Vadodara travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Pune to Vadodara cab taxi quickly and securely via our website or app with immediate confirmation."
  }
]




















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer Pune to Vadodara cab taxi services?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab taxi services from Pune to Vadodara with professional drivers and well-maintained vehicles.',
    },
    {
        question: 'How can I book a cab taxi from Pune to Vadodara?',
        answer: 'You can book your cab easily via our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for Pune to Vadodara travel?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit your preferences and budget.',
    },
    {
        question: 'Is one-way cab taxi service available from Pune to Vadodara?',
        answer: 'Yes, both one-way and round-trip cab taxi services are available for Pune to Vadodara travel.',
    },
    {
        question: 'Are the drivers experienced for Pune to Vadodara long-distance trips?',
        answer: 'Absolutely, our drivers are licensed, experienced, and familiar with the Pune to Vadodara route.',
    },
    {
        question: 'Can I customize my pickup and drop-off locations in Pune and Vadodara?',
        answer: 'Yes, you can specify your exact pickup and drop-off points according to your convenience.',
    },
    {
        question: 'What safety and hygiene protocols are followed for Pune to Vadodara cab taxis?',
        answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene measures to ensure a safe journey.',
    },
    {
        question: 'Is Pune to Vadodara cab taxi service available 24x7?',
        answer: 'Yes, Platinum24 Cabs offers 24x7 services for Pune to Vadodara cab taxi bookings.',
    },
    {
        question: 'What payment options are accepted for Pune to Vadodara cab taxi bookings?',
        answer: 'We accept cash, UPI, digital wallets, and major credit/debit cards for easy payment.',
    },
    {
        question: 'Are there customizable packages for Pune to Vadodara cab taxi service?',
        answer: 'Yes, we provide flexible and customizable packages tailored to your travel requirements.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Karan Mehta',
        feedback: 'My Pune to Vadodara trip was very comfortable thanks to Platinum24 Cabs. The driver was courteous and the car was spotless.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Sneha Joshi',
        feedback: 'Excellent service for Pune to Vadodara cab taxi. Timely pickup and great overall experience.',
        rating: 5,
    },
];










































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const puneToVadodaraCabSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Vadodara Cab Service",
  "image": "https://www.platinum24cab.com/assets/images/pune-to-vadodara-cab.jpg",
  "description": "Book Pune to Vadodara cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",
    "ratingCount": "32150",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5599",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/pune-to-vadodara-cab-service"
  }
};







    return (
        <div>

<Helmet>
  <title>Pune to Vadodara Cab Service | Affordable Outstation Taxi | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Book Pune to Vadodara cab service with Platinum24 Cabs. Choose from affordable sedans, SUVs, and reliable outstation taxis for one-way and round trips. Comfortable and available 24/7."
  />
  <meta
    name="keywords"
    content="Pune to Vadodara Cab, Pune to Vadodara Taxi, Book Pune to Vadodara Cab, Pune to Vadodara Car Hire, Pune to Vadodara Outstation Cab, Pune to Vadodara One Way Taxi, Pune to Vadodara Taxi Booking, Cab from Pune to Vadodara, Vadodara to Pune Cab Service, Affordable Pune to Vadodara Cabs, Pune to Vadodara Drop Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToVadodaraCabSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/104.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetovadodaracabtaxi;